module.exports = __webpack_public_path__ + "static/media/yash rao.217654a9.png";